<template>
	<div>
		<div class="h-panel-search">
			<Row type="flex" :space-x="10">
				<Cell style="line-height: 32px;">输入编码或名称：</Cell>
				<Cell><input type="text" v-model="keyword" @keydown.enter="doSearch"></Cell>
				<Cell>
					<Button color="green" @click="doSearch"> 查询</Button>
				</Cell>
				<Cell :flex="1" class="text-right">
<!--					<Button color="primary" @click="add">新增</Button>-->
<!--					<Button @click="showImportModal=true">导入</Button>-->
          <Button color="primary" @click="add" :disabled="!hasAssetsPermission">新增</Button>
          <Button @click="showImportModal=true" :disabled="!hasAssetsPermission">导入</Button>
					<a :href="downloadUrl" class="h-btn">导出</a>
<!--					<Button @click="clearData">清空</Button>-->
				</Cell>
			</Row>
		</div>
		<div>
			<Table :datas="datas" border>
				<TableItem :title="category.name+'编码'" prop="code" :width="80"></TableItem>
				<TableItem :title="category.name+'名称'" prop="name" :width="280"></TableItem>
				<TableItem v-for="(col,i) in customColumns" :title="col" :prop="'cusColumn'+i" :key="col"></TableItem>
				<TableItem title="备注" prop="remark"></TableItem>
				<TableItem title="操作" :width="120" align="center">
					<div class="actions" slot-scope="{data}">
<!--						<span @click="edit(data)">编辑</span>-->
            <span @click="edit(data)" :style="{cursor: hasAssetsPermission ? 'pointer' : 'not-allowed', opacity: hasAssetsPermission ? 1 : 0.5}">编辑</span>
						<span @click="remove1(data)">删除</span>
					</div>
				</TableItem>
			</Table>
			<div class="margin-top-bottom">
				<Pagination v-model="pageInfo" align="center" layout="pager" small/>
			</div>
		</div>
		<Modal v-model="showForm" type="drawer-right" hasCloseIcon>
			<div slot="header">辅助核算设置 - {{category.name}}</div>
			<Form ref="form" v-width="800" mode="twocolumn" :labelWidth="150" :model="form" :rules="validationRules">
				<FormItem :label="category.name+'编码'" prop="code">
					<input type="text" v-model="form.code" maxlength="18" :disabled="!!form.id">
				</FormItem>
				<FormItem :label="category.name+'名称'" prop="name">
					<input type="text" v-model="form.name">
				</FormItem>
				<FormItem v-for="(col,i) in customColumns" :label="col" :key="i">
					<DatePicker v-model="form['cusColumn'+i]" v-if="col.indexOf('日期') != -1"/>
					<input v-else type="text" v-model="form['cusColumn'+i]">
				</FormItem>
				<FormItem label="备注" prop="remark" single>
					<NumberInput v-model="form.remark"></NumberInput>
				</FormItem>
				<FormItem v-if="category.name === '部门'" label="管理部门" prop="enable" single>
					<Radio v-model="form.enable" dict="defaultRadios"/>
				</FormItem>
			</Form>
			<div class="text-center">
				<Button color="green" @click="submit" :loading="loading">{{form.id?'更新':'保存'}}</Button>
				<Button @click="showForm=false" :loading="loading">取消</Button>
			</div>
		</Modal>
		<Modal v-model="showImportModal" :closeOnMask="false">
			<div slot="header">批量导入 {{category.name}} 数据</div>
			<div class="padding" v-width="350">
				<p>第一步： 请点击下面的链接下载Excel模板，并按照模板填写信息</p>
				<a class="blue-color text-hover" :href="downTemplateUrl">下载模板</a>
				<p>第二步： 导入Excel模板文件</p>
				<span class="blue-color text-hover" @click="$refs.file.click()">选取文件</span><span class="margin-left" v-if="fileName">已选：{{fileName}}</span>
				<input type="file" style="visibility: hidden;" @change="fileChange($event)" ref="file">
			</div>
			<div class="text-center">
				<Button color="green" @click="importData" :disabled="!fileName" :loading="loading">导入</Button>
				<Button @click="showImportModal=false" :loading="loading">取消</Button>
			</div>
		</Modal>
	</div>
</template>
<script>

	import Ajax from "@/js/common/ajax";

  const emptyForm = {
		"code": "",
		"name": "",
		"enable": false
	};
  /**
   * 部门往来设置。
   * 并提供分页展示功能。
   */
	export default {
		name: "CategoryCustom",
				/**
		 * 组件接收的属性配置
		 * 用于从父组件传递数据到当前组件
		 */
		props: {
			/**
			 * 辅助核算类别的唯一标识
			 * 支持数字和字符串类型
			 * 该属性用于区分不同的辅助核算类别，在 API 请求中作为参数使用
			 */
			id: [Number, String]
		},

		data() {
			return {
								// 搜索关键词，用于在表格中进行数据筛选
				keyword: '',
				// 存储用户选择的用于导入的文件对象，初始为 null
				file: null,
				// 存储表格展示的数据，初始为空数组
				datas: [],
				// 存储表格列配置信息，初始为空数组
				columns: [],
				// 存储辅助核算类别的详细信息，初始为空对象
				category: {},
				// 存储自定义列的信息，初始为空数组
				customColumns: [],
				// 表单数据对象，通过复制 emptyForm 对象初始化，避免直接修改原始对象
				form: Object.assign({}, emptyForm),
				// 表单验证规则，定义需要进行必填项验证的字段
				validationRules: {
					// 定义 code 和 name 字段为必填项
					required: ["code", "name"],
				},
				// 控制新增/编辑表单弹窗的显示与隐藏，false 表示隐藏
				showForm: false,
				// 控制导入数据弹窗的显示与隐藏，false 表示隐藏
				showImportModal: false,
				// 控制按钮加载状态的布尔值，true 表示正在加载
				loading: false,
				// 分页信息对象，包含当前页码和数据总条数
				pageInfo: {
					// 当前页码，初始为第 1 页
					page: 1,
					// 数据总条数，初始为 0
					total: 0
				}

			};
		},
		computed: {

      hasAssetsPermission() {
        const accountSets = this.$store.state.currentAccountSets;
        // console.log('currentAccountSets:', accountSets);

        if (!accountSets) {
          return false;
        }

        // 判断固定资产模块是否启用（0: 未启用, 1: 启用）
        return accountSets.fixedAssetModule === 1;
      },

						/**
			 * 计算下载模板文件的 URL
			 * @returns {string} 下载模板文件的完整 URL
			 */
			downTemplateUrl() {
				// 拼接模板文件下载的 URL，包含 API 前缀和当前辅助核算类别的 ID
				return Ajax.PREFIX + "/accounting-category/template?categoryId=" + this.id;
			},
			/**
			 * 计算下载数据文件的 URL
			 * @returns {string} 下载数据文件的完整 URL
			 */
			downloadUrl() {
				// 拼接数据文件下载的 URL，包含 API 前缀和当前辅助核算类别的 ID
				return Ajax.PREFIX + "/accounting-category/download?categoryId=" + this.id;
			},
			/**
			 * 获取用户选择的文件名称
			 * @returns {string} 若用户选择了文件，则返回文件名；否则返回空字符串
			 */
			fileName() {
				// 检查是否存在用户选择的文件
				if (this.file) {
					// 若存在文件，则返回文件的名称
					return this.file.name;
				}
				// 若不存在文件，则返回空字符串
				return '';
			}

		},
    watch: {
			/**
			 * 监听 showForm 属性的变化
			 * 当 showForm 的值变为 false 时，意味着新增/编辑表单弹窗关闭，
			 * 此时调用 reset 方法重置表单数据。
			 * @param {boolean} val - showForm 的新值
			 */
			showForm(val) {
				if (!val) {
					// 当弹窗关闭时，重置表单数据
					this.reset();
				}
			},
			/**
			 * 监听 id 属性的变化
			 * 当 id 发生变化时，说明辅助核算类别的唯一标识改变，
			 * 此时先调用 reset 方法重置表单数据，再调用 init 方法重新初始化组件数据。
			 */
			id() {
				// 重置表单数据
				this.reset();
				// 重新初始化组件数据
				this.init();
			},
			/**
			 * 监听 pageInfo 对象的变化
			 * 使用 deep 选项深度监听 pageInfo 对象的所有属性变化，
			 * 当 pageInfo 发生变化时，调用 loadList 方法重新加载数据列表。
			 */
			pageInfo: {
				deep: true, // 深度监听 pageInfo 对象的所有属性变化
				/**
				 * 当 pageInfo 对象发生变化时的处理函数
				 * 调用 loadList 方法重新加载数据列表
				 */
				handler() {
					// 重新加载数据列表
					this.loadList();
				}
			}
		},

		mounted() {
			this.init();
		},
		methods: {
			doSearch() {
				this.pageInfo.page = 1;
				this.loadList();
			},
						/**
			 * 初始化组件数据
			 * 该方法会调用 API 获取当前辅助核算类别的详细信息，
			 * 并根据返回的数据更新组件的 category 和 customColumns 属性，
			 * 最后在 DOM 更新完成后加载数据列表。
			 */
			init() {
				// 调用 API 获取指定辅助核算类别的详细信息
				this.$api.setting.accountingCategory.load(this.id).then(({data}) => {
					// 将 API 返回的辅助核算类别详细信息赋值给组件的 category 属性
					this.category = data;
					// 检查返回数据中的 customColumns 字段是否有值
					// 若有值，则将其按逗号分割成数组赋值给 customColumns 属性；若无值，则赋值为空数组
					this.customColumns = data.customColumns.length ? data.customColumns.split(",") : [];
					// 加载数据
					// 使用 $nextTick 确保在 DOM 更新完成后再调用 loadList 方法加载数据列表
					this.$nextTick(() => {
						this.loadList();
					});
				})
			},

						/**
			 * 加载辅助核算类别详情列表数据
			 * 该方法会调用 API 获取指定辅助核算类别下的详情列表数据，
			 * 并更新组件的表格数据和分页信息。
			 */
			loadList() {
				// 调用 API 获取辅助核算类别详情列表数据
				// 传递辅助核算类别的唯一标识、当前页码和搜索关键词作为参数
				this.$api.setting.accountingCategoryDetails.list(this.id, {page: this.pageInfo.page, keyword: this.keyword}).then(({data}) => {
					// 将 API 返回的记录数据赋值给组件的 datas 属性，用于表格展示
					this.datas = data.records;
					// 使用 Vue 的 $set 方法更新分页信息中的总数据条数，确保响应式更新
					this.$set(this.pageInfo, 'total', data.total);
				})
			},
      /**
       * 新增表单数据
       */
      async add() {
        if (!this.hasAssetsPermission) {
          this.$Message.error('您没有权限新增部门信息！');
          return;
        }
        this.showForm = true;
        // 自动生成编号
        this.form.code = await this.generateNextCode();
      },
      /**
       * 生成下一个编号
       */
      async generateNextCode() {
        try {
          // 获取当前类别的所有数据
          const response = await this.$api.setting.accountingCategoryDetails.list(this.id, {page: 1, size: 9999});
          const data = response.data.records;

          if (!data || data.length === 0) {
            // 如果没有数据，从 0001 开始
            return this.getCategoryPrefix() + '01001';
          }

          // 提取所有编号并过滤出符合格式的编号
          const codes = data
              .map(item => item.code)
              .filter(code => code && this.isValidCodeFormat(code));

          if (codes.length === 0) {
            // 如果没有符合格式的编号，从 0001 开始
            return this.getCategoryPrefix() + '01001';
          }

          // 获取最大编号并加1
          const maxCode = codes.reduce((max, code) => {
            const num = parseInt(this.extractNumberFromCode(code));
            const maxNum = parseInt(this.extractNumberFromCode(max));
            return num > maxNum ? code : max;
          }, this.getCategoryPrefix() + '00000');

          const nextNum = parseInt(this.extractNumberFromCode(maxCode)) + 1;
          // 保持与原编号相同的长度，而不是固定4位
          const numLength = this.extractNumberFromCode(maxCode).length;
          return this.getCategoryPrefix() + nextNum.toString().padStart(numLength, '0');
        } catch (error) {
          console.error('生成编号失败:', error);
          // 出错时返回默认编号
          return this.getCategoryPrefix() + new Date().getTime().toString().slice(-4);
        }
      },
      /**
       * 获取类别前缀
       */
      getCategoryPrefix() {
        if (this.category && this.category.name) {
          const categoryName = this.category.name;
          // 根据类别名称设置不同的前缀
          if (categoryName === '部门') {
            return 'BM';
          } else if (categoryName === '往来') {
            return 'WL';
          } else {
            // 其他类别使用首字母作为前缀
            return categoryName.substring(0, 1).toUpperCase();
          }
        }
        return 'A';
      },
      /**
       * 检查编号格式是否有效
       */
      isValidCodeFormat(code) {
        const prefix = this.getCategoryPrefix();
        // 支持4位或更多位数字
        const regex = new RegExp(`^${prefix}\\d{4,}$`);
        return regex.test(code);
      },
      /**
       * 从编号中提取数字部分
       */
      extractNumberFromCode(code) {
        const prefix = this.getCategoryPrefix();
        return code.substring(prefix.length);
      },
      /**
       * 提交表单数据的方法
       * 该方法用于保存或更新辅助核算分类的自定义项，执行表单验证后调用 API 进行数据持久化
       * @returns {void} 无返回值
       */
			submit() {
        // 对表单进行验证，获取验证结果
				let validResult = this.$refs.form.valid();

        // 如果表单验证通过，则执行保存操作
				if (validResult.result) {
          // 设置加载状态为 true，显示加载动画
					this.loading = true;
          // 根据是否存在 form.id 判断是更新还是新增操作，调用对应的 API
          // 将 accountingCategoryId 和表单数据合并后传递给后端
					this.$api.setting.accountingCategoryDetails[this.form.id ? 'update' : 'save'](Object.assign({
						accountingCategoryId: this.category.id
					}, this.form)).then(() => {
            // 保存成功后，重新加载列表数据
						this.loadList();
            // 隐藏表单弹窗
						this.showForm = false;
            // 关闭加载状态
						this.loading = false;
					}).catch(() => {
            // 保存失败时，关闭加载状态
						this.loading = false;
					})
				}
			},
			edit(data) {
        if (!this.hasAssetsPermission) {
          this.$Message.error('您没有权限修改部门信息！');
          return;
        }
				this.form = Object.assign({}, data);
				this.showForm = true;
			},



      remove1(data) {
				this.$Confirm("确认删除？").then(() => {
					// 先验证是否被使用
					this.loading = true;
					this.$api.setting.accountingCategoryDetails.checkUse1({id: data.id, code: data.code}).then(({data: isUsed}) => {
						if (!isUsed) {
							// 已被使用，不能删除
							this.$Message.error('该分类已被使用，不能删除');
							this.loading = false;
							return;
						}

						// 未被使用，执行删除
						this.$api.setting.accountingCategoryDetails.delete(data.id).then(() => {
							this.loadList();
							this.$Message.success('删除成功');
						}).catch(error => {
							if (error && error.msg) {
								this.$Message.error(error.msg);
							} else if (error.response && error.response.data && error.response.data.msg) {
								this.$Message.error(error.response.data.msg);
							} else {
								this.$Message.error('删除失败');
							}
						}).finally(() => {
							this.loading = false;
						});
					}).catch(error => {
						// 验证接口调用失败时的处理
						console.error('验证失败:', error);
						this.loading = false;
						this.$Message.error('验证失败，请稍后重试');
					});
				});
			},


			reset() {
				this.form = Object.assign({}, emptyForm);
			},
			clearData() {
				this.$Confirm("亲，您确认要清空所有的数据吗?").then(() => {
					this.$api.setting.accountingCategoryDetails.clearData(this.category.id).then(() => {
						this.loadList();
					})
				});
			},
			fileChange() {
				this.file = this.$refs.file.files[0];
			},
			importData() {
				if (this.file) {
					let formData = new FormData();
					formData.append('file', this.file);
					formData.append('categoryId', this.id);
					this.loading = true;
					this.$api.setting.accountingCategory.import(formData).then(({data}) => {
						this.$Message(`本次导入数据共:${data.total}行。其中更新${data.updated}行，新增${data.inserted}行。`);
						this.pageInfo.page = 1;
						this.showImportModal = false;
						this.loadList();
					}).finally(() => {
						this.loading = false;
					});
					this.file = null;
					this.$refs.file.value = "";
				}
			}
		}
	};
</script>
<style lang='less'>
	div.h-panel-search {
		margin-bottom: 10px;
	}
</style>
